import { ClientHelper } from '../client/CreateNswagClient';
import { FolderRenameRequest, UploadedFileModel } from '../client/SmartAssistantBackendClient';
import { buildFilesUploadUrl, postFilesFormData } from '../utils/fileUpload';

export class AssistantFilesService {
  static async listFiles(token: string, assistantInternalName: string | null, subfolder: string | null) {
    const filesClient = ClientHelper.createFilesClient(token);
    const folder = subfolder === '' ? null : subfolder ?? null;
    return filesClient.list(folder, assistantInternalName ?? null);
  }

  static async embedFile(token: string, assistantInternalName: string | null, fileUrl: string) {
    const filesClient = ClientHelper.createFilesClient(token);
    return filesClient.embedByUrl(fileUrl, assistantInternalName ?? null);
  }

  static async deleteFile(token: string, assistantInternalName: string | null, fileUrl: string) {
    const filesClient = ClientHelper.createFilesClient(token);
    await filesClient.delete(fileUrl, assistantInternalName ?? null);
  }

  static async renameFolder(token: string, assistantInternalName: string | null, sourcePath: string, targetPath: string) {
    const filesClient = ClientHelper.createFilesClient(token);
    const payload = new FolderRenameRequest({ sourceFolder: sourcePath, targetFolder: targetPath });
    await filesClient.renameFolder(assistantInternalName ?? null, payload);
  }

  static async deleteFolder(token: string, assistantInternalName: string | null, folderPath: string) {
    const filesClient = ClientHelper.createFilesClient(token);
    await filesClient.deleteFolder(folderPath, assistantInternalName ?? null);
  }

  static async uploadFiles(token: string, assistantInternalName: string | null, subfolder: string | null, files: File[]) {
    if (!files.length) return [];
    const url = buildFilesUploadUrl({ endpoint: 'upload', subfolder, assistantInternalName });
    const json = await postFilesFormData(url, files, token);
    const entries = Array.isArray(json) ? json : json?.items ?? [];
    return (entries as any[]).map(item => UploadedFileModel.fromJS(item));
  }
}
